<span *ngFor="let m of members| slice:0:4; let i=index">
                <a class="inline" tooltip="{{m.firstName}} {{m.lastName}}">
                  <img class="rounded-circle thumb24" *ngIf="m.image"  src="{{m.image}}">
                  <div class="rounded-circle  img-profil__photo24" *ngIf="!m.image" [innerHTML]="m.firstName|user2Lettre:m.lastName"></div>
                </a>
              </span>
<a class="inline" *ngIf="members.length>4">
  <strong>+{{members.length - 4}}</strong>
</a>
